import React from "react";

const Spinner = ({
  size = "md",
  color = "blue",
  className = "",
  label = "Loading...",
  showLabel = false,
}) => {
  const sizeClasses = {
    xs: "h-3 w-3",
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
    xl: "h-16 w-16",
  };

  const colorClasses = {
    blue: "border-blue-500",
    gray: "border-gray-500",
    red: "border-red-500",
    green: "border-green-500",
    yellow: "border-yellow-500",
    indigo: "border-indigo-500",
    purple: "border-purple-500",
    pink: "border-pink-500",
    white: "border-white",
    primary: "border-primary",
  };

  const spinnerSize = sizeClasses[size] || sizeClasses.md;
  const spinnerColor = colorClasses[color] || colorClasses.blue;

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div
        className={`animate-spin rounded-full border-b-2 ${spinnerSize} ${spinnerColor}`}
        role="status"
        aria-label={label}
      />
      {showLabel && <span className="mt-2 text-sm text-gray-500">{label}</span>}
      <span className="sr-only">{label}</span>
    </div>
  );
};

export default Spinner;
